import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'obtenKeys'
})
export class ObtenKeysPipe implements PipeTransform {

  transform(value: any, args: any[] = null): any {
    return Object.keys(value);
  }
}
